import { withFirebase } from 'react-redux-firebase';
import { withHandlers, compose } from 'recompose';
import { UserIsNotAuthenticated } from 'utils/router';
import { withNotifications } from 'modules/notification';
import { withStyles } from '@material-ui/core/styles';
import styles from './ReferrerSignupPage.styles';
import { firestoreConnect, withFirestore } from 'react-redux-firebase';
import { spinnerWhileLoading } from 'utils/components';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { setPropTypes, withProps } from 'recompose';

export default compose(
  // Redirect to list page if logged in
  UserIsNotAuthenticated,
  // Add props.showError
  withNotifications,
  // Add props.firebase (used in handlers)
  withFirebase,
  setPropTypes({
    match: PropTypes.shape({
      params: PropTypes.shape({
        organisation: PropTypes.string
      }).isRequired
    }).isRequired
  }),
  withProps(({ match: { params: { organisation } } }) => ({
    organisation
  })),
  firestoreConnect(() => [
    {
      collection: 'organisations',
      orderBy: ['name', 'desc'],
      limit: 100,
      storeAs: 'dataSet'
    }
  ]),
  connect(({ firestore }) => ({
    organisations: firestore.ordered.dataSet
  })),
  spinnerWhileLoading(['organisations']),
  // Add handlers as props
  withHandlers({
    onSubmitFail: props => (formErrs, dispatch, err) => {
      //console.log(formErrs, err);
      props.showError(formErrs ? 'Form Invalid ' : err.message || 'Error');
    },
    googleLogin: ({ firebase, showError }) => e =>
      firebase.login({ provider: 'google', type: 'popup' }).catch(err => showError(err.message)),
    emailSignup: ({ firebase, showError }) => creds => {
      //console.log(creds);
      firebase
        .createUser(creds, {
          email: creds.email,
          username: creds.username || creds.firstname + creds.lastname,
          phone: creds.phone || '',
          firstname: creds.firstname || '',
          lastname: creds.lastname || '',
          role: creds.userRole || 'client',
          emailVerified: false,
          verificationEmailSent: false
        })
        .catch(err => showError(err.message));
    },
    referrerSignup: ({ firebase, showError }) => creds => {
      //console.log(creds);
      if (
        creds.detail.firstname == null ||
        creds.detail.lastname == null ||
        creds.detail.email == null ||
        creds.detail.password == null ||
        creds.detail.phone == null ||
        creds.address.organisation == null ||
        creds.address.state == null ||
        creds.address.postcode == null ||
        creds.address.suburb == null ||
        creds.address.addressLine == null
      ) {
        showError('missing details');
        return;
      }
      creds.email = creds.detail.email;
      creds.password = creds.detail.password;
      firebase
        .createUser(creds, {
          email: creds.detail.email || '',
          phone: creds.detail.phone || '',
          firstname: creds.detail.firstname || '',
          lastname: creds.detail.lastname || '',
          role: 'referrer',
          state: creds.address.state || '',
          postcode: creds.address.postcode || '',
          suburb: creds.address.suburb || '',
          organisation: creds.address.organisation || '',
          addressLine: creds.address.addressLine || '',
          //addressLine2: creds.address.addressLine2 || '',
          adminApproved: false,
          emailVerified: false,
          verificationEmailSent: false
        })
        .catch(err => showError(err.message));
    }
  }),
  // Add styles as props.classes
  withStyles(styles)
);
